import { render } from "./CapsuleToyResult.vue?vue&type=template&id=f0118c1c&scoped=true"
import script from "./CapsuleToyResult.vue?vue&type=script&lang=js"
export * from "./CapsuleToyResult.vue?vue&type=script&lang=js"

import "./CapsuleToyResult.vue?vue&type=style&index=0&id=f0118c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0118c1c"]])

export default __exports__